const location2 = (() => {
  if (document.querySelector("body#pageLocation") !== null) {
    if (document.querySelector("section#jsSecCntnt") !== null) {



      let sW = window.innerWidth;

      if (sW > 768) {

        let sec = document.querySelector('#jsSecCntnt');
        let pinWrap = sec.querySelector('.js-pin-wrap');

        let trgs = sec.querySelectorAll('.js-trg');


        let to = gsap.to('#jsSecCntnt .js-pin-wrap', {
          scrollTrigger: {
            invalidateOnRefresh: true,
            trigger: '#jsSecCntnt .js-pin-wrap',
            start: '0% 0%',
            endTrigger: '#jsSecCntnt',
            end: '100% 100%',
            pin: true,
            // markers: true,
          }
        });
        let target = document.querySelector('body');
        let observer = new ResizeObserver((entries) => {
          entries.forEach((entry) => {
            to.scrollTrigger.refresh()
            // console.log('comParallax refresh');
          });
        });
        observer.observe(target);


        trgs.forEach((element, index) => {

          let tl = gsap.timeline({
            scrollTrigger: {
              invalidateOnRefresh: true,
              trigger: element,
              start: "0% 25%",
              endTrigger: 'body',
              end: '100% 0%',
              onEnter: () => {
                trgs.forEach((element2, index2) => {
                  pinWrap.classList.remove(`is-act-${index2}`)
                });
                pinWrap.classList.add(`is-act-${index}`)
              },
              // onLeave: () => console.log("onLeave"),
              // onEnterBack: () => console.log("onEnterBack"),
              onLeaveBack: () => {
                trgs.forEach((element2, index2) => {
                  pinWrap.classList.remove(`is-act-${index2}`)
                });
                if (index != 0) {
                  pinWrap.classList.add(`is-act-${index - 1}`)
                }
              },
              // markers: true,
            },
          })
          let target = document.querySelector('body');
          let observer = new ResizeObserver((entries) => {
            entries.forEach((entry) => {
              tl.scrollTrigger.refresh()
            });
          });
          observer.observe(target);

        });

      }



    }
  }
})()
export default location2;